export default function SuspenseUi() {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="loader"></div>
    </div>
  );
}
